import React, { useContext } from 'react'
import listContext from '../../../Common/context/context'
import updatePropertyList from '../../Utility/UpdatePropertyList/UpdatePropertyList'
import { determineDistanceFromSubject } from '../../Utility/PropertyListUtility'

const SelectSubject = () => {

    const { propertyList, setPropertyList } = useContext(listContext)

    const getCompsList = () => {

        let returnVal = []
        if (propertyList && propertyList.compsList) {
            returnVal = [...propertyList.compsList]
        }

        return returnVal
    }

    const addSubjectPropertyToUpdateReq = (selectedId, copyPropertyList) => {
        let updatedCompsList = []
        let rank = 1
        copyPropertyList.forEach(item => {
            if (item.isSubjectProperty && item.omniViewPropertyId !== selectedId) {
                updatedCompsList.push({
                    ...item,
                    "omniViewPropertyId": item.omniViewPropertyId,
                    "isSubjectProperty": item.isSubjectProperty,
                    "rank": rank,
                })
                rank++
            }
        })
        return updatedCompsList
    }

    const addCompsPropertyToUpdateReq = (compsRankStartsFrom, selectedId, copyPropertyList) => {
        let updatedCompsList = []
        let rank = compsRankStartsFrom ? compsRankStartsFrom : 1
        copyPropertyList.forEach(item => {
            if (!item.isSubjectProperty && item.omniViewPropertyId !== selectedId) {
                // copyPropertyList.rank = rank
                updatedCompsList.push({
                    ...item,
                    "omniViewPropertyId": item.omniViewPropertyId,
                    "isSubjectProperty": item.isSubjectProperty,
                    "rank": rank
                })
                rank++
            }
        })
        return updatedCompsList
    }

    const handleAddProperty = (compsItem, copyPropertyList) => {
        let updatedCompsList = []
        let updateSubPropsList = addSubjectPropertyToUpdateReq(compsItem.omniViewPropertyId, copyPropertyList)
        let currentRank = updateSubPropsList.length + 1
        currentRank = currentRank ? currentRank : 1
        if (!compsItem.isSubjectProperty) {
            updateSubPropsList.push({
                ...copyPropertyList.filter(item => item.omniViewPropertyId === compsItem.omniViewPropertyId)[0],
                "omniViewPropertyId": compsItem.omniViewPropertyId,
                "isSubjectProperty": true,
                "rank": currentRank
            })
            currentRank++
        }
        let updateCompPropsList = addCompsPropertyToUpdateReq(updateSubPropsList.length + 1, compsItem.omniViewPropertyId, copyPropertyList)
        currentRank = updateSubPropsList.length + updateCompPropsList.length + 1
        currentRank = currentRank ? currentRank : 1
        if (compsItem.isSubjectProperty) {
            updateCompPropsList.push({
                ...copyPropertyList.filter(item => item.omniViewPropertyId === compsItem.omniViewPropertyId)[0],
                "omniViewPropertyId": compsItem.omniViewPropertyId,
                "isSubjectProperty": false,
                "rank": currentRank
            })
            currentRank++
        }
        updatedCompsList = [...updateSubPropsList, ...updateCompPropsList]
        return updatedCompsList
    }


    const handleToggleSubject = compsItem => {

        let fieldsToUpdate = []
        let omniViewPropertyListId = propertyList.omniViewPropertyListId
        let polarisPropertySearchCriteriaId = propertyList.polarisPropertySearchCriteriaId

        let newCompsList = [...getCompsList()]
        let updatedCompsList = handleAddProperty(compsItem, newCompsList)

        fieldsToUpdate.push({ key: 'compType', value: propertyList.compType })
        fieldsToUpdate.push({ key: 'omniViewPropertyListId', value: omniViewPropertyListId })
        fieldsToUpdate.push({ key: 'polarisPropertySearchCriteriaId', value: polarisPropertySearchCriteriaId })
        fieldsToUpdate.push({
            key: 'compsList', value: updatedCompsList.map(item => ({
                "omniViewCompsListId": item.omniViewCompsListId,
                "omniViewPropertyId": item.omniViewPropertyId,
                "isSubjectProperty": item.isSubjectProperty,
                "rank": item.rank,
                "action": "modify"
            }))
        })

        const updatePropertyListObj = new updatePropertyList(fieldsToUpdate)
        updatePropertyListObj.update()

        let newPropertyList = { ...propertyList }

        updatedCompsList = determineDistanceFromSubject(updatedCompsList)

        newPropertyList.compsList = updatedCompsList

        setPropertyList(newPropertyList)
    }

    return (
        <>
            <div className="bg-white px-6 pt-6 pb-4">
                <div className="w-full">
                    <span className="font-medium form-control-lg">Subject Properties</span>
                </div>
                <div className="w-full flex flex-wrap py-4 space-x-2">
                    {getCompsList().map((compsItem, index) => (
                        <span key={index} data-testid={`test-select-sub-${index}`} onClick={() => handleToggleSubject(compsItem)} className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-4 py-3 ${compsItem.isSubjectProperty ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}>
                            {compsItem.data.omniviewproperty[0].propertyName}
                            {/* {compsItem.isSubjectProperty ?
                                <span className="-mr-3">
                                    <button type="button">
                                        <i className="fa fa-close"></i>
                                    </button>
                                </span>
                                : null} */}

                        </span>
                    ))}
                </div>
            </div>
        </>
    )
}

export default SelectSubject
